<div class="flex h-full flex-col justify-between">
  <div class="header flex flex-row items-center justify-between p-[30px]">
    <div class="flex flex-row items-center gap-[15px]">
      <ion-icon src="../../../assets/icon/carpeta.svg"></ion-icon>
      <h1>{{ this.item.product.folderName }}</h1>
    </div>
    <ion-button fill="clear" color="dark" (click)="dismiss()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="content" (scroll)="appService.closeAllTooltips()">
    <div class="flex flex-row items-center justify-between gap-[15px]">
      <div class="flex w-full flex-row items-center gap-[30px]">
        <span class="fileCount"
          >{{ item.product.printingGroup.files.length }} archivo{{
            item.product.printingGroup.files.length > 1 ? 's' : ''
          }}</span
        >
        <span class="price">{{ item.price.amt | currency: item.price.cur }}</span>

        <div class="qtyCounter flex flex-row items-center gap-2.5">
          <label>Copias</label>
          <span>{{ item.qty }}</span>
        </div>
      </div>

      @if (cartService.exceededBindingItems(item.product.printingGroup).length) {
        <div class="noStock w-full font-medium">
          <span>No hay stock suficiente para los siguientes elementos:</span>
          <ul>
            <li *ngFor="let element of cartService.exceededBindingItems(item.product.printingGroup)">
              {{ element }}
            </li>
          </ul>
        </div>
      }
    </div>

    <app-print-settings-labels
      [printSettings]="item.product.printingGroup.printSettings"
      [files]="item.product.printingGroup.files"
      [size]="'large'"
    >
    </app-print-settings-labels>

    @if (printSettings.grouped && item.product.printingGroup.binding) {
      <div class="binding-settings flex w-full flex-row items-center gap-[15px] p-2.5">
        <div class="flex flex-row items-center gap-[5px]">
          <img
            class="ring-img"
            [src]="'assets/images/binding/rings/' + bindingOptionValue('ringColor', 'id') + '.png'"
          />
          <div class="flex flex-row gap-0.5">
            <span class="file-text" [ngClass]="{ noStock: false }"
              >Anillas: {{ bindingOptionValue('ringColor', 'name') }}</span
            >
          </div>
        </div>

        <div class="flex flex-row items-center gap-[5px]">
          <app-cover-thumbnail
            [id]="bindingOptionValue('hardCoverFront', 'id')"
            [color]="bindingOptionValue('hardCoverFront', 'color')"
            [width]="'20px'"
            [height]="'24px'"
          >
          </app-cover-thumbnail>
          <div class="flex flex-row gap-0.5">
            <ng-container *ngIf="!printSettings.coverLaminated">
              <span class="file-text">
                Tapa delantera: {{ utils.getColorName(bindingOptionValue('hardCoverFront', 'name')) }}
              </span>
            </ng-container>
            <ng-container *ngIf="printSettings.coverLaminated">
              <span class="file-text bold coverColorTag">
                Portada {{ fileService.getLaminationTypeName(printSettings.laminationType) }},
                {{
                  fileService.getLaminationWeightName(
                    printSettings.laminationWeight,
                    printSettings.laminationType,
                    printSettings.coverLaminated
                  )
                }}
                <span *ngIf="!printSettings.coverLaminated">({{ printSettings.laminationWeight }} micras)</span> </span
              >&nbsp;
            </ng-container>
          </div>
        </div>

        <div class="flex flex-row items-center gap-[5px]">
          <app-cover-thumbnail
            [id]="bindingOptionValue('hardCoverBack', 'id')"
            [color]="bindingOptionValue('hardCoverBack', 'color')"
            [width]="'20px'"
            [height]="'24px'"
          >
          </app-cover-thumbnail>
          <div class="flex flex-row gap-0.5">
            <span class="file-text"
              >Tapa trasera: {{ utils.getColorName(bindingOptionValue('hardCoverBack', 'name')) }}</span
            >
          </div>
        </div>
      </div>
    }

    @if (printSettings.grouped) {
      <div class="files-container flex flex-col gap-[10px] p-[15px]">
        @if (printSettings.finishing === finishing.BINDING) {
          <div class="flex flex-row items-center justify-between py-[5px]">
            <span class="binding-label">Encuadernación agrupada</span>

            @if (warningMessage !== '') {
              <ion-icon id="warning" class="warning-icon" src="../../../assets/icon/alert-yellow.svg"></ion-icon>
              <ion-popover class="warning-popover" trigger="warning">
                <ng-template>
                  <div class="flex flex-col items-center gap-[15px]">
                    <span class="warning-title">Encuadernado</span>
                    <span class="warning-message">{{ warningMessage }}</span>
                  </div>
                </ng-template>
              </ion-popover>
            }
          </div>

          <div class="divider"></div>
        }

        <div class="file-info-wrapper">
          <div class="file-info-container flex flex-row items-center justify-between">
            <span class="blank-sheets-text">Folios en blanco por <span>DELANTE:</span></span>
            <span class="blank-sheets-number">{{ files[0].blankSheetsBefore || 0 }}</span>
          </div>
        </div>

        <div class="divider"></div>

        @for (file of files; track file.id) {
          <div class="flex flex-row gap-[15px]">
            <img class="file-img" src="{{ file.thumbFile?.url }}" alt="" />
            <div class="flex flex-col gap-0.5">
              <span class="file-name">{{ file.alias }}</span>
              @if (
                ![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(printSettings.finishing)
              ) {
                <div class="flex flex-col gap-0.5">
                  <div class="flex flex-row items-center gap-[5px]">
                    <img
                      class="coverTypeIcon"
                      [src]="
                        fileService.getCoverTypeImage(file.coverType, {
                          docColor: file.docColor,
                          twoSided: printSettings.twoSided,
                          pagesPerSheet: printSettings.pagesPerSheet,
                        })
                      "
                      alt=""
                    />
                    <span class="leading-4">
                      {{
                        getCoverTypeSetting(file).title + (getCoverTypeSetting(file).value.twoSided ? '' : ', una cara')
                      }}
                    </span>
                  </div>

                  <div class="annotations-row flex flex-row flex-wrap items-center gap-[5px]">
                    @if (
                      ![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(
                        printSettings.finishing
                      )
                    ) {
                      <span class="blue"
                        >{{ file.coverLaminated ? printSettings.paperWeight : file.coverType.paperWeight }}gr</span
                      >
                    }
                    @if (printSettings.twoSided && getCoverTypeSetting(file).value.twoSided) {
                      <span class="yellow">Sin despaginación</span>
                    }
                    @if (printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided) {
                      <span class="pink">Con despaginación</span>
                    }
                    @if (printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided) {
                      <span class="pink">Desconfigura tu documento</span>
                    }
                  </div>
                </div>
              }
              <div class="flex flex-row items-center gap-[5px]">
                <ion-icon
                  class="text-lg"
                  [src]="file.docColor ? 'assets/icon/color-indicator.svg' : 'assets/icon/black-white-indicator.svg'"
                ></ion-icon>
                <span class="file-color">
                  {{ file.docColor ? 'Interior en color' : 'Interior en blanco y negro' }}</span
                >
              </div>
              <span class="file-pages"> Nº Páginas: {{ file.pages }} </span>
            </div>
          </div>

          <div class="divider"></div>
        }

        <div class="file-info-wrapper">
          <div class="file-info-container flex flex-row items-center justify-between">
            <span class="blank-sheets-text">Folios en blanco por <span>DETRÁS:</span></span>
            <span class="blank-sheets-number">{{ files[files.length - 1].blankSheetsAfter || 0 }}</span>
          </div>
        </div>
      </div>
    } @else {
      <div class="flex flex-col gap-2.5">
        @for (file of files; track file.id) {
          <app-file-details [file]="file" [printingGroup]="item?.product?.printingGroup"></app-file-details>
        }
      </div>
    }
  </div>

  @if (!inOrderDetail) {
    <div class="footer flex flex-row items-center justify-end gap-2.5 p-[15px]">
      <ion-button (click)="editPrintProduct()">
        <ion-icon src="../../../assets/icon/lapizEditar.svg"></ion-icon>
        <span>Editar carpeta</span>
      </ion-button>
      <ion-button
        id="print-product-actions"
        fill="clear"
        color="dark"
        tooltip="Más acciones"
        tooltipClass="no-transition"
        [hideDelay]="0"
      >
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
      <ion-popover trigger="print-product-actions" dismissOnSelect="true">
        <ng-template>
          <app-folder-actions-menu [inCart]="true" [modal]="true" [item]="item"></app-folder-actions-menu>
        </ng-template>
      </ion-popover>
    </div>
  }
</div>
